import { ElCheckbox, ElForm, ElFormItem, type CheckboxValueType } from 'element-plus'
import { CustomButton } from 'ui-components'
import { SizedBox } from 'crypto-otc/components/SizedBox'
import { storageDB, StorageIndexDBEnum } from 'store/src/storage/StorageDB'
import { useI18n } from 'i18n-utils'
import './SecurityDialog.scss'
import { DialogHeader, HocElDialog, UiUtils } from 'ui-components'
import { useAppInfoStore, useUserInfoStore } from 'store'
import { useLoginStore } from 'crypto-otc/hooks/components/use-login'
import { useChangeLanguage } from 'store'
import { PlatformName } from 'platform-config'

export const SecurityDialog = defineComponent({
  props: {},
  setup() {
    const userInfoStore = useUserInfoStore()
    const loginStore = useLoginStore()
    const appInfoStore = useAppInfoStore()
    const { t } = useI18n()
    const onRecharge = async () => {
      if (!agree.value) {
        UiUtils.showError(t('请先同意此声明'))
        return
      }
      storageDB.set(StorageIndexDBEnum.AgreeNotice + userInfoStore.userInfo?.userId, true)
      appInfoStore.showSecurityAgreeDialog = false
    }
    const agree = ref<CheckboxValueType>(false)

    useChangeLanguage(async () => {
      loginStore.checkIsAgree()
    })
    return () => (
      <HocElDialog v-model={appInfoStore.showSecurityAgreeDialog} showClose={false} closeOnClickModal={false} width={440}>
        {{
          header: () => <DialogHeader showClose={false}>{t('提示')}</DialogHeader>,
          default: () => (
            <div class="security-dialog-layout">
              <SizedBox height={12} />
              <ElForm labelPosition="top">
                <div class={'tips'}>
                  {t(
                    '本人在此确认并申明：本人非古巴、伊朗、朝鲜、叙利亚以及其他受到相关国家或政府或国际机构管理或执行的制裁的国家或地区居民。{platformName}提供的服务在本人所在的国家或地区是符合法律法规和相关政策的。',
                    {
                      platformName: t(PlatformName),
                    },
                  )}
                </div>
                <div class={'agree'}>
                  <ElCheckbox modelValue={agree.value} onUpdate:modelValue={(val) => (agree.value = val)}>
                    {t('由于本人所在的国家或地区使用{platformName}提供的服务系违法导致的所有法律风险和责任将完全由本人独立承担', {
                      platformName: t(PlatformName),
                    })}
                  </ElCheckbox>
                </div>
                <SizedBox height={12} />
                <ElFormItem style={{ marginBottom: 0 }}>
                  <CustomButton class={'transfer-confirm-btn'} type="primary" onClick={onRecharge}>
                    {t('确认')}
                  </CustomButton>
                </ElFormItem>
              </ElForm>
            </div>
          ),
        }}
      </HocElDialog>
    )
  },
})
